import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import CanvasDraw from "react-canvas-draw";
import { Button, Overlay } from "../../../components";

const SignatureModal = ({ onSave, onClose }) => {
  const canvasRef = useRef(null);
  const [canvasWidth, setCanvasWidth] = useState(undefined);

  const handleWindowSizeChange = () => {
    if (window.innerWidth > 480) {
      setCanvasWidth(460);
      return;
    }

    setCanvasWidth(window.innerWidth * 0.8);
  };

  useEffect(() => {
    handleWindowSizeChange();
    window.addEventListener("resize", handleWindowSizeChange);

    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  return (
    <Overlay
      onClose={onClose}
      content={
        <div className="tendering-contract__signature">
          <h3>Draw your signature</h3>
          {canvasWidth && (
            <CanvasDraw
              ref={canvasRef}
              brushColor="rgb(39, 70, 186)"
              brushRadius={3}
              lazyRadius={0}
              canvasWidth={canvasWidth}
              canvasHeight={canvasWidth / 2}
            />
          )}
          <div className="tendering-contract__signature__footer">
            <Button
              label="Clear"
              variant={"tertiary"}
              onClick={() => {
                canvasRef.current.clear();
              }}
            />
            <div className="tendering-contract__signature__footer__right">
              <Button
                label="Cancel"
                variant={"secondary"}
                size={"small"}
                onClick={onClose}
              />
              <Button
                label="Save"
                size={"small"}
                onClick={() => {
                  const imageData = canvasRef.current.getDataURL(
                    "png",
                    false,
                    "#fff"
                  );

                  onSave(imageData);
                }}
              />
            </div>
          </div>
        </div>
      }
    />
  );
};

SignatureModal.propTypes = {};

export default SignatureModal;
